import { render } from "./SelfidgesPopUP.vue?vue&type=template&id=01205ba8&scoped=true"
import script from "./SelfidgesPopUP.vue?vue&type=script&lang=js"
export * from "./SelfidgesPopUP.vue?vue&type=script&lang=js"

import "./SelfidgesPopUP.vue?vue&type=style&index=0&id=01205ba8&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01205ba8"]])

export default __exports__